<template>
  <v-menu
    v-model="open"
    :close-on-content-click="false"
    :min-width="500"
    offset-y
  >
    <template #activator="{ on, attrs }">
      <v-badge
        class="screen-tab-filtering-button-badge"
        :value="badgeCount > 0"
        :content="badgeCount"
        color="primary"
        bottom
        overlap
      >
        <v-btn v-bind="attrs" icon v-on="on">
          <v-icon>filter_list</v-icon>
        </v-btn>
      </v-badge>
    </template>
    <screen-tab-filtering-controls
      :filtering-input.sync="filterInputModel"
      :review="review"
      @apply="onApply"
    />
  </v-menu>
</template>

<script>
import ScreenTabFilteringControls from './ScreenTabFilteringControls';
import { ReferenceFilteringInputDto, Review } from '@/models';
import { cloneDeep } from 'lodash';

export default {
  name: 'ScreenTabFilteringButton',
  components: {
    ScreenTabFilteringControls,
  },
  props: {
    filteringInput: {
      type: ReferenceFilteringInputDto,
      required: true,
    },
    review: {
      type: Review,
      required: true,
    },
  },
  emits: ['update:filteringInput'],
  data: () => ({
    open: false,
    filterInputModel: new ReferenceFilteringInputDto(),
  }),
  computed: {
    badgeCount() {
      return this.filteringInput.appliedFiltersCount();
    },
  },
  watch: {
    open: function (value) {
      // Reset the model when the dialog is opened
      if (value) {
        this.filterInputModel = cloneDeep(this.filteringInput);
      }
    },
  },
  mounted() {
    this.filterInputModel = cloneDeep(this.filteringInput);
  },
  methods: {
    onApply() {
      this.$emit('update:filteringInput', this.filterInputModel);
      this.open = false;
    },
  },
};
</script>

<style>
.screen-tab-filtering-button-badge .v-badge__badge {
  min-width: 14px !important;
  height: 14px !important;
  border-radius: 14px !important;
  padding: 2px;
  font-size: 10px !important;
  inset: calc(100% - 16px) auto auto calc(100% - 12px) !important;
}
</style>
